module.exports = __webpack_public_path__ + "static/flags/KI-90da607c54f32d6cb4beb296a808dcfd.gif";